import * as React from 'react';
import EnrollmentTimelineDisplayRow from 'flow-doctor-lib/components/timeline/EnrollmentTimelineDisplayRow';
import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { View } from 'foundations-components/components/View';
import TimelineItemIcon from 'flow-doctor-lib/components/timeline/TimelineItemIcon';
import { makeTimelineItemHash, sortTimelineLogItems } from 'flow-doctor-lib/utils/timelineItemUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentTimeline = ({
  flowId,
  timelineLogItems,
  objectTypeId,
  sortByPersistence = false
}) => {
  const logItems = React.useMemo(() => sortTimelineLogItems(timelineLogItems, sortByPersistence), [sortByPersistence, timelineLogItems]);
  const EnrollmentTimelineDisplayIcon = React.useCallback(props => /*#__PURE__*/_jsx(TimelineItemIcon, Object.assign({}, props, {
    size: "200",
    logItem: logItems[props.index]
  })), [logItems]);
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: "1600",
    position: "relative",
    children: /*#__PURE__*/_jsx(StepIndicator, {
      direction: "vertical",
      stepNames: logItems.map((logItem, index) => /*#__PURE__*/_jsx(EnrollmentTimelineDisplayRow, {
        logItem: logItem,
        flowId: flowId,
        focused: window.location.hash === makeTimelineItemHash(logItem),
        objectTypeId: objectTypeId,
        usePersistedTimestamp: sortByPersistence
      }, `${index}-${makeTimelineItemHash(logItem)}`)),
      StepIconComponent: EnrollmentTimelineDisplayIcon
      // @ts-expect-error inlineSize is not a valid prop
      ,
      inlineSize: "100%"
    })
  });
};
export default EnrollmentTimeline;